import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { AsyncPipe } from '@angular/common';
import { TextareaFieldComponent, ButtonComponent } from 'htx-ui-library';
import { Observable } from 'rxjs';
import { AdmissionState } from '../../../services/organizations/organization.model';

@Component({
  selector: 'app-admission-decision',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoDirective,
    TranslocoPipe,
    AsyncPipe,
    TextareaFieldComponent,
    ButtonComponent
  ],
  templateUrl: './admission-decision.component.html',
  styleUrl: './admission-decision.component.scss'
})
export class AdmissionDecisionComponent {
  approvalForm = input.required<FormGroup>();
  admissionState$ = input.required<Observable<AdmissionState | undefined>>();
  existingReasoning$ = input.required<Observable<string>>();

  approve = output<void>();
  reject = output<void>();

  isReasoningEmpty(): boolean {
    const reasoning = this.approvalForm().controls['reasoning'].value;
    return !reasoning || reasoning.trim().length === 0;
  }

  onApprove(): void {
    this.approve.emit();
  }

  onReject(): void {
    this.reject.emit();
  }
}
